/**
 * Warstwa API: KOMUNIKATY PRACOWNIKA — ponowne przeczytanie jednego komunikatu (S16, 2026-09-14).
 *
 * Trasa backendu: `GET api/announcements/moje/{id}` — wyłącznie dla ODBIORCY komunikatu (wiersz odbiorcy konta).
 * Nieodbiorca i komunikat usunięty dostają to samo 404. Odczyt NICZEGO nie zapisuje: nie potwierdza zapoznania się
 * (potwierdzenie składa się w oknie komunikatu wyświetlanym przez aplikację) i nie niesie statusów innych odbiorców.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca nazwane metody doczepiane do
 * wspólnego `apiService`. Nazwy muszą być unikalne w całej aplikacji (patrz attachApiModules).
 */
export function attach(api) {
    return {
        /** Jeden komunikat dla zalogowanego odbiorcy — także już potwierdzony i pasek u góry aplikacji. */
        getMyAnnouncement: (id) => api.get(`/announcements/moje/${id}`),
    };
}
